import { render, staticRenderFns } from "./tabsDemo.vue?vue&type=template&id=6ec94f50&"
import script from "./tabsDemo.vue?vue&type=script&lang=js&"
export * from "./tabsDemo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/mychefkoo/Documents/cloud-dom/cloud-web/erp-flexible-web21/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ec94f50')) {
      api.createRecord('6ec94f50', component.options)
    } else {
      api.reload('6ec94f50', component.options)
    }
    module.hot.accept("./tabsDemo.vue?vue&type=template&id=6ec94f50&", function () {
      api.rerender('6ec94f50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/listSet/com/tabsDemo.vue"
export default component.exports